var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 741.037,
    height: 389.66,
    viewBox: "0 0 741.037 389.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANES",
    transform: "translate(-177.963 -423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M865.327,447.844A83.748,83.748,0,0,0,765.035,335.412a175.411,175.411,0,0,0-304.984,12.14,35.028,35.028,0,0,0-55.139,41.8A175.512,175.512,0,0,0,288.04,620.938h670.3a137.356,137.356,0,0,0-93.016-173.093Z",
    transform: "translate(-51.57 191.722)",
    fill: "#a8d9f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(434.847 687.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M1272.394,1423.183a69.153,69.153,0,0,0-66.476,50.115H1338.87A69.153,69.153,0,0,0,1272.394,1423.183Z",
    transform: "translate(-1205.918 -1401.714)",
    fill: "#64a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M2075.433,1423.183a69.153,69.153,0,0,0-66.476,50.115h132.952A69.154,69.154,0,0,0,2075.433,1423.183Z",
    transform: "translate(-1827.601 -1401.714)",
    fill: "#64a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M1595.225,1328.119a98.777,98.777,0,0,0-94.953,71.584h189.907A98.778,98.778,0,0,0,1595.225,1328.119Z",
    transform: "translate(-1433.796 -1328.119)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874",
    transform: "translate(717.346 630.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(27.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M2581.808,1099.016a16.818,16.818,0,0,0-2.067-11.827c-3.567-6.17,1.261-9.9,4.284-8.165S2589.488,1087.869,2581.808,1099.016Z",
    transform: "translate(-2578.481 -1078.6)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(12.418 8.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M2525.685,1132.119a16.819,16.819,0,0,0-9.135-7.791c-6.683-2.477-5.34-8.425-1.908-9.021S2524.489,1118.636,2525.685,1132.119Z",
    transform: "translate(-2511.799 -1115.251)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    transform: "translate(26.988 21.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M2576.316,1178.507a16.82,16.82,0,0,1,11.6,3.1c5.833,4.1,9.968-.388,8.509-3.551S2588.094,1171.835,2576.316,1178.507Z",
    transform: "translate(-2576.316 -1174.53)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(20.738 32.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M2548.64,1225.68a16.819,16.819,0,0,1,11.6,3.1c5.833,4.1,9.968-.388,8.509-3.551S2560.418,1219.008,2548.64,1225.68Z",
    transform: "translate(-2548.64 -1221.703)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(17.609 43.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M2534.787,1274.363a16.818,16.818,0,0,1,11.6,3.1c5.834,4.1,9.968-.388,8.509-3.551S2546.565,1267.692,2534.787,1274.363Z",
    transform: "translate(-2534.787 -1270.386)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(14.325 57.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M2520.242,1335.353a16.817,16.817,0,0,1,11.6,3.1c5.833,4.1,9.968-.388,8.509-3.55S2532.019,1328.681,2520.242,1335.353Z",
    transform: "translate(-2520.242 -1331.376)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870",
    transform: "translate(6.925 19.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M2501.362,1181.12a16.818,16.818,0,0,0-9.135-7.79c-6.683-2.477-5.34-8.426-1.908-9.021S2500.167,1167.637,2501.362,1181.12Z",
    transform: "translate(-2487.477 -1164.252)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(2.918 31.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M2483.618,1234.943a16.818,16.818,0,0,0-9.135-7.791c-6.683-2.477-5.34-8.425-1.908-9.021S2482.423,1221.46,2483.618,1234.943Z",
    transform: "translate(-2469.733 -1218.075)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872",
    transform: "translate(0 44.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M2470.7,1290.327a16.818,16.818,0,0,0-9.135-7.79c-6.683-2.477-5.34-8.426-1.908-9.021S2469.5,1276.844,2470.7,1290.327Z",
    transform: "translate(-2456.813 -1273.459)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(10.827 17.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M2507.114,1253.559a.605.605,0,0,0,.449-.685,174.421,174.421,0,0,1-1.31-34.235c1.014-17.772,5.281-43.109,19.846-62.885a.6.6,0,0,0-.974-.718c-14.747,20.024-19.06,45.617-20.081,63.562a175.655,175.655,0,0,0,1.325,34.472.6.6,0,0,0,.695.5Z",
    transform: "translate(-2504.754 -1154.791)",
    fill: "#ffb3b0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(748.358 629.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(60.563 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M2862.3,1093.215a19.8,19.8,0,0,0,2.753-13.866c-1.3-8.292,5.588-10.332,8.173-7.147S2875.473,1084.235,2862.3,1093.215Z",
    transform: "translate(-2862.305 -1070.773)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876",
    transform: "translate(43.612 2.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M2797.248,1105.058a19.8,19.8,0,0,0-6.724-12.436c-6.288-5.558-2.286-11.521,1.735-10.717S2801.662,1089.743,2797.248,1105.058Z",
    transform: "translate(-2787.25 -1081.832)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877",
    transform: "translate(54.152 26.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M2833.918,1186.656a19.8,19.8,0,0,1,11.424,8.328c4.667,6.975,11.112,3.808,10.853-.285S2849.687,1184.332,2833.918,1186.656Z",
    transform: "translate(-2833.918 -1186.154)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(42.762 35.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M2783.486,1226.708a19.8,19.8,0,0,1,11.424,8.328c4.667,6.975,11.111,3.808,10.853-.285S2799.254,1224.384,2783.486,1226.708Z",
    transform: "translate(-2783.486 -1226.206)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(34.657 45.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M2747.594,1274.289a19.805,19.805,0,0,1,11.424,8.328c4.667,6.975,11.111,3.808,10.853-.285S2763.362,1271.964,2747.594,1274.289Z",
    transform: "translate(-2747.594 -1273.787)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    transform: "translate(25.199 59.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M2705.714,1335.092a19.8,19.8,0,0,1,11.424,8.328c4.667,6.975,11.111,3.808,10.853-.285S2721.483,1332.768,2705.714,1335.092Z",
    transform: "translate(-2705.714 -1334.59)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(32.88 12.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M2749.722,1148.54A19.8,19.8,0,0,0,2743,1136.1c-6.288-5.559-2.286-11.521,1.736-10.717S2754.137,1133.225,2749.722,1148.54Z",
    transform: "translate(-2739.724 -1125.314)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(23.316 23.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M2707.374,1200.115a19.806,19.806,0,0,0-6.723-12.436c-6.288-5.558-2.286-11.521,1.736-10.717S2711.788,1184.8,2707.374,1200.115Z",
    transform: "translate(-2697.376 -1176.889)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(14.799 36.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M2669.661,1255.452a19.806,19.806,0,0,0-6.723-12.436c-6.288-5.559-2.287-11.521,1.735-10.717S2674.076,1240.137,2669.661,1255.452Z",
    transform: "translate(-2659.664 -1232.225)",
    fill: "#ffb3b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(0 19.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M2594.761,1256.643a.713.713,0,0,0,.784-.562,205.39,205.39,0,0,1,13.1-38.155c8.663-19.087,24.111-45.1,48.506-60.632a.712.712,0,0,0-.765-1.2c-24.7,15.727-40.308,42-49.052,61.276a206.85,206.85,0,0,0-13.187,38.422.713.713,0,0,0,.552.843Z",
    transform: "translate(-2594.135 -1155.981)",
    fill: "#ffb3b0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(276.065 625.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(24.708 22.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M662.784,1252.308a243.775,243.775,0,0,0-10.535-33.857,267.385,267.385,0,0,0-15.046-32.509,210.09,210.09,0,0,0-23.271-34.257l-1.688,1.425a207.858,207.858,0,0,1,23.023,33.9,265.276,265.276,0,0,1,14.921,32.239,241.386,241.386,0,0,1,10.434,33.513Z",
    transform: "translate(-612.244 -1151.685)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(7.101 0.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M547.1,1065.268a45.017,45.017,0,0,1,7.836,14.677,43.075,43.075,0,0,1-20.649-25.289A45.013,45.013,0,0,1,547.1,1065.268Z",
    transform: "translate(-534.282 -1054.656)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(31.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M647.385,1069.966a45.013,45.013,0,0,1-4.848,15.915,43.073,43.073,0,0,1,3.3-32.481A45.016,45.016,0,0,1,647.385,1069.966Z",
    transform: "translate(-640.789 -1053.4)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(0 29.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M519.34,1189.75a45.018,45.018,0,0,1-16.5-2.111,43.073,43.073,0,0,1,32.575-2.191A45.016,45.016,0,0,1,519.34,1189.75Z",
    transform: "translate(-502.837 -1183.25)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(9.399 42.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M560.865,1248.524a45.018,45.018,0,0,1-16.409,2.746,43.072,43.072,0,0,1,30.554-11.506A45.017,45.017,0,0,1,560.865,1248.524Z",
    transform: "translate(-544.456 -1239.744)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(18.224 58.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M600.122,1318.338a45.016,45.016,0,0,1-16.588,1.286,43.073,43.073,0,0,1,31.451-8.764A45.011,45.011,0,0,1,600.122,1318.338Z",
    transform: "translate(-583.534 -1310.596)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(25.719 73.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M633.345,1385.4a45.015,45.015,0,0,1-16.623.687,43.075,43.075,0,0,1,31.746-7.623A45.012,45.012,0,0,1,633.345,1385.4Z",
    transform: "translate(-616.722 -1377.998)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(32.806 90.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M664.511,1462.423a45.013,45.013,0,0,1-16.409,2.746,43.073,43.073,0,0,1,30.554-11.506A45.011,45.011,0,0,1,664.511,1462.423Z",
    transform: "translate(-648.102 -1453.644)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(40.239 14.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M691.516,1133.394a45.017,45.017,0,0,1-10.5,12.9,43.074,43.074,0,0,1,15.334-28.824A45.014,45.014,0,0,1,691.516,1133.394Z",
    transform: "translate(-681.012 -1117.473)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(57.051 53.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M770.246,1304.013a45.01,45.01,0,0,1-14.789,7.621,43.072,43.072,0,0,1,25.587-20.279A45.01,45.01,0,0,1,770.246,1304.013Z",
    transform: "translate(-755.457 -1291.355)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(63.78 77.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M801.476,1405.725a45.01,45.01,0,0,1-16.225,3.68A43.072,43.072,0,0,1,815.1,1396.17,45.012,45.012,0,0,1,801.476,1405.725Z",
    transform: "translate(-785.251 -1396.17)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(49.543 33.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M734.563,1214.56a45.014,45.014,0,0,1-12.349,11.15,43.072,43.072,0,0,1,19.551-26.147A45.016,45.016,0,0,1,734.563,1214.56Z",
    transform: "translate(-722.214 -1199.562)",
    fill: "#64a6c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(363.213 570.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(29.735 32.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M1022.846,1087.535a282.145,282.145,0,0,0,7.472-40.358,309.49,309.49,0,0,0,2.125-41.41,243.168,243.168,0,0,0-5.355-47.637l-2.5.548a240.61,240.61,0,0,1,5.3,47.134,306.964,306.964,0,0,1-2.108,41.066,279.306,279.306,0,0,1-7.391,39.951Z",
    transform: "translate(-1020.388 -958.131)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(27.651 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M1019.4,830.452a52.1,52.1,0,0,1,.109,19.258A49.858,49.858,0,0,1,1012,812.672,52.1,52.1,0,0,1,1019.4,830.452Z",
    transform: "translate(-1011.162 -812.672)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(37.551 15.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M1068.549,898.7A52.1,52.1,0,0,1,1055,912.381a49.86,49.86,0,0,1,20.9-31.485A52.108,52.108,0,0,1,1068.549,898.7Z",
    transform: "translate(-1055 -880.896)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(3.188 30.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M918.6,958.38a52.1,52.1,0,0,1-15.763-11.063,49.857,49.857,0,0,1,34.544,15.327A52.1,52.1,0,0,1,918.6,958.38Z",
    transform: "translate(-902.84 -947.317)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(2.083 54.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M916.235,1060.2a52.11,52.11,0,0,1-18.287-6.039,49.859,49.859,0,0,1,37.5,4.7A52.112,52.112,0,0,1,916.235,1060.2Z",
    transform: "translate(-897.948 -1052.457)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(3.838 73.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M923.4,1147.454a52.107,52.107,0,0,1-17.682-7.63,49.857,49.857,0,0,1,36.937,7.989A52.1,52.1,0,0,1,923.4,1147.454Z",
    transform: "translate(-905.717 -1139.101)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(3.81 92.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M922.989,1231.718a52.109,52.109,0,0,1-17.4-8.263,49.856,49.856,0,0,1,36.625,9.317A52.111,52.111,0,0,1,922.989,1231.718Z",
    transform: "translate(-905.593 -1223.01)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(0 116.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M907.01,1335.17a52.1,52.1,0,0,1-18.287-6.039,49.86,49.86,0,0,1,37.5,4.7A52.107,52.107,0,0,1,907.01,1335.17Z",
    transform: "translate(-888.723 -1327.431)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(39.232 40.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M1080.157,1006.476a52.11,52.11,0,0,1-17.717,7.549,49.86,49.86,0,0,1,31.252-21.249A52.1,52.1,0,0,1,1080.157,1006.476Z",
    transform: "translate(-1062.44 -992.776)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(39.878 94.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M1084.559,1239.266a52.1,52.1,0,0,1-19.257-.172,49.859,49.859,0,0,1,37.144-6.967A52.1,52.1,0,0,1,1084.559,1239.266Z",
    transform: "translate(-1065.302 -1231.142)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(37.8 120.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M1074.7,1354.1a52.108,52.108,0,0,1-18.6-4.982,49.86,49.86,0,0,1,37.706,2.543A52.108,52.108,0,0,1,1074.7,1354.1Z",
    transform: "translate(-1056.101 -1346.576)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(40.206 66.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M1085.413,1120.62a52.105,52.105,0,0,1-18.661,4.758,49.855,49.855,0,0,1,34.127-16.234A52.107,52.107,0,0,1,1085.413,1120.62Z",
    transform: "translate(-1066.752 -1109.144)",
    fill: "#64a6c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    transform: "translate(219.191 435.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M295.265,278.427A46.049,46.049,0,0,0,251,311.8h88.533A46.049,46.049,0,0,0,295.265,278.427Z",
    transform: "translate(-250.998 -264.131)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M830.013,278.427A46.049,46.049,0,0,0,785.746,311.8h88.533A46.049,46.049,0,0,0,830.013,278.427Z",
    transform: "translate(-664.98 -264.131)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M510.24,215.124a65.776,65.776,0,0,0-63.23,47.668H573.47A65.776,65.776,0,0,0,510.24,215.124Z",
    transform: "translate(-402.743 -215.124)",
    fill: "#d0f1f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(236.543 469.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M349.351,394.782A22.384,22.384,0,0,0,327.833,411h43.036A22.385,22.385,0,0,0,349.351,394.782Z",
    transform: "translate(-327.833 -387.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M609.291,394.782A22.385,22.385,0,0,0,587.773,411h43.036A22.385,22.385,0,0,0,609.291,394.782Z",
    transform: "translate(-529.069 -387.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M453.85,364.01a31.974,31.974,0,0,0-30.736,23.172h61.472A31.974,31.974,0,0,0,453.85,364.01Z",
    transform: "translate(-401.596 -364.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(611.145 439.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M2010.888,267.026a25.309,25.309,0,0,0-24.329,18.341h48.658A25.309,25.309,0,0,0,2010.888,267.026Z",
    transform: "translate(-1986.559 -259.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M2304.785,267.026a25.309,25.309,0,0,0-24.329,18.341h48.658A25.309,25.309,0,0,0,2304.785,267.026Z",
    transform: "translate(-2214.083 -259.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M2129.038,232.235a36.151,36.151,0,0,0-34.751,26.2h69.5A36.151,36.151,0,0,0,2129.038,232.235Z",
    transform: "translate(-2069.958 -232.235)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(367.073 752.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M1297.028,1644.878H918.482a12.667,12.667,0,0,1,0-25.334h378.546a12.667,12.667,0,0,1,0,25.334Z",
    transform: "translate(-905.815 -1619.544)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(673.609 460.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M2277.082,343.321a14.5,14.5,0,0,0-13.935,10.505h27.869A14.5,14.5,0,0,0,2277.082,343.321Z",
    transform: "translate(-2263.147 -338.821)",
    fill: "#ffcbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M2445.413,343.321a14.5,14.5,0,0,0-13.935,10.505h27.869A14.5,14.5,0,0,0,2445.413,343.321Z",
    transform: "translate(-2393.463 -338.821)",
    fill: "#ffcbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M2344.753,323.394a20.705,20.705,0,0,0-19.9,15.005h39.808A20.705,20.705,0,0,0,2344.753,323.394Z",
    transform: "translate(-2310.915 -323.394)",
    fill: "#ffcbc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(772.251 505.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M2730.972,566.591a32.287,32.287,0,0,0-31.037,23.4h62.075A32.287,32.287,0,0,0,2730.972,566.591Z",
    transform: "translate(-2699.935 -556.567)",
    fill: "#64a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M3105.908,566.591a32.287,32.287,0,0,0-31.037,23.4h62.074A32.287,32.287,0,0,0,3105.908,566.591Z",
    transform: "translate(-2990.197 -556.567)",
    fill: "#64a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M2881.7,522.206a46.119,46.119,0,0,0-44.333,33.422h88.667A46.119,46.119,0,0,0,2881.7,522.206Z",
    transform: "translate(-2806.331 -522.206)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(415.702 423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M1136.661,180.791a16.143,16.143,0,0,0-15.519,11.7h31.037A16.143,16.143,0,0,0,1136.661,180.791Z",
    transform: "translate(-1121.142 -175.779)",
    fill: "#64a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M1324.128,180.791a16.144,16.144,0,0,0-15.519,11.7h31.038A16.144,16.144,0,0,0,1324.128,180.791Z",
    transform: "translate(-1266.272 -175.779)",
    fill: "#64a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M1212.024,158.6a23.059,23.059,0,0,0-22.166,16.711h44.333A23.06,23.06,0,0,0,1212.024,158.6Z",
    transform: "translate(-1174.339 -158.598)",
    fill: "#64a6c4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 6.759,
    cy: 6.759,
    r: 6.759,
    transform: "translate(653.748 492.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 6.759,
    cy: 6.759,
    r: 6.759,
    transform: "translate(821.791 716.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 6.759,
    cy: 6.759,
    r: 6.759,
    transform: "translate(645.729 668.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 6.759,
    cy: 6.759,
    r: 6.759,
    transform: "translate(432.147 565.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(646.708 722.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M2176.224,1529.485a33.487,33.487,0,0,0-32.19,24.268h64.381A33.487,33.487,0,0,0,2176.224,1529.485Z",
    transform: "translate(-2144.034 -1519.089)",
    fill: "#ffcbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M2565.088,1529.485a33.486,33.486,0,0,0-32.19,24.268h64.38A33.487,33.487,0,0,0,2565.088,1529.485Z",
    transform: "translate(-2445.078 -1519.089)",
    fill: "#ffcbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M2332.552,1483.451a47.832,47.832,0,0,0-45.98,34.664h91.961A47.832,47.832,0,0,0,2332.552,1483.451Z",
    transform: "translate(-2254.381 -1483.451)",
    fill: "#ffcbc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    transform: "translate(284.276 716.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M578.6,1513.542a41,41,0,0,0-39.408,29.709h78.815A41,41,0,0,0,578.6,1513.542Z",
    transform: "translate(-539.192 -1500.815)",
    fill: "#91c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M1054.649,1513.542a41,41,0,0,0-39.408,29.709h78.815A40.994,40.994,0,0,0,1054.649,1513.542Z",
    transform: "translate(-907.732 -1500.815)",
    fill: "#91c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M769.977,1457.187a58.556,58.556,0,0,0-56.289,42.436H826.267A58.556,58.556,0,0,0,769.977,1457.187Z",
    transform: "translate(-674.28 -1457.187)",
    fill: "#91c9e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    transform: "translate(737.055 526.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M2563.773,646.541a20.478,20.478,0,0,0-19.686,14.841h39.371A20.478,20.478,0,0,0,2563.773,646.541Z",
    transform: "translate(-2544.088 -640.183)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M2801.582,646.541a20.478,20.478,0,0,0-19.686,14.841h39.372A20.478,20.478,0,0,0,2801.582,646.541Z",
    transform: "translate(-2728.19 -640.183)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M2659.376,618.39a29.252,29.252,0,0,0-28.119,21.2H2687.5A29.252,29.252,0,0,0,2659.376,618.39Z",
    transform: "translate(-2611.571 -618.39)",
    fill: "#d0f1f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    transform: "translate(573.142 603.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M1848.011,998.719a30.923,30.923,0,0,0-29.725,22.41h59.451A30.923,30.923,0,0,0,1848.011,998.719Z",
    transform: "translate(-1818.286 -989.119)",
    fill: "#91c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M2207.1,998.719a30.923,30.923,0,0,0-29.726,22.41h59.451A30.923,30.923,0,0,0,2207.1,998.719Z",
    transform: "translate(-2096.279 -989.119)",
    fill: "#91c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M1992.37,956.21a44.17,44.17,0,0,0-42.46,32.01h84.919A44.169,44.169,0,0,0,1992.37,956.21Z",
    transform: "translate(-1920.184 -956.21)",
    fill: "#91c9e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(527.326 469.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M1626.005,379.942a11.022,11.022,0,0,0-10.6,7.988H1636.6A11.022,11.022,0,0,0,1626.005,379.942Z",
    transform: "translate(-1615.41 -376.52)",
    fill: "#91c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M1754,379.942a11.022,11.022,0,0,0-10.6,7.988h21.191A11.022,11.022,0,0,0,1754,379.942Z",
    transform: "translate(-1714.498 -376.52)",
    fill: "#91c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M1677.46,364.79a15.743,15.743,0,0,0-15.134,11.41h30.269A15.744,15.744,0,0,0,1677.46,364.79Z",
    transform: "translate(-1651.731 -364.79)",
    fill: "#91c9e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(630.799 626.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M2086.124,1075.623a13.042,13.042,0,0,0-12.537,9.451h25.073A13.041,13.041,0,0,0,2086.124,1075.623Z",
    transform: "translate(-2073.587 -1071.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M2237.57,1075.623a13.043,13.043,0,0,0-12.537,9.451h25.073A13.041,13.041,0,0,0,2237.57,1075.623Z",
    transform: "translate(-2190.831 -1071.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M2147.007,1057.695a18.629,18.629,0,0,0-17.907,13.5h35.815A18.629,18.629,0,0,0,2147.007,1057.695Z",
    transform: "translate(-2116.563 -1057.695)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 3.772,
    cy: 3.772,
    r: 3.772,
    transform: "translate(634.372 518.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 3.772,
    cy: 3.772,
    r: 3.772,
    transform: "translate(676.998 655.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(647.869 687.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(15.058 57.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M2413.193,1605.107a15.7,15.7,0,0,1,15.087,11.374h-30.174A15.694,15.694,0,0,1,2413.193,1605.107Z",
    transform: "translate(-2356.946 -1600.234)",
    fill: "#6a678a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M2230.937,1605.107a15.7,15.7,0,0,1,15.087,11.374H2215.85A15.7,15.7,0,0,1,2230.937,1605.107Z",
    transform: "translate(-2215.85 -1600.234)",
    fill: "#6a678a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M2295.613,1583.532a22.418,22.418,0,0,1,21.55,16.247h-43.1A22.418,22.418,0,0,1,2295.613,1583.532Z",
    transform: "translate(-2260.916 -1583.532)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(0 21.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(11.979 5.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M2233.956,1492.055l-1.174,1.258a131.142,131.142,0,0,1-12.017-13.435c-5.976-7.6-14.046-19.481-18.552-32.881l1.631-.548c4.428,13.167,12.381,24.869,18.274,32.367A129.2,129.2,0,0,0,2233.956,1492.055Z",
    transform: "translate(-2202.213 -1446.448)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(8.588 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 3.191,
    cy: 3.191,
    r: 3.191,
    transform: "translate(0 6.033) rotate(-70.991)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(0 8.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M2154.525,1463.726a3.191,3.191,0,1,0,.184,4.509A3.191,3.191,0,0,0,2154.525,1463.726Z",
    transform: "translate(-2149.172 -1462.882)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(28.184 11.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M2279.324,1476.663a3.191,3.191,0,1,0,.184,4.509A3.191,3.191,0,0,0,2279.324,1476.663Z",
    transform: "translate(-2273.971 -1475.818)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(4.619 11.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M2184.869,1483.181l-1.059,1.356c-.069-.054-6.945-5.38-14.185-7.55l.494-1.648C2177.675,1477.6,2184.579,1482.954,2184.869,1483.181Z",
    transform: "translate(-2169.625 -1475.339)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(23.897 15.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M2256.689,1506.608l-1.7-.24a34.767,34.767,0,0,1,5.682-13.351l1.425.965A33.539,33.539,0,0,0,2256.689,1506.608Z",
    transform: "translate(-2254.986 -1493.017)",
    fill: "#6a678a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(27.452 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(12.993 5.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M2334.777,1408.913l-1.648.493a131.176,131.176,0,0,1-3.587-17.665c-1.317-9.581-2.284-23.908.594-37.749l1.685.35c-2.829,13.6-1.874,27.718-.574,37.165A129.173,129.173,0,0,0,2334.777,1408.913Z",
    transform: "translate(-2328.262 -1353.992)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(11.795)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 3.191,
    cy: 3.191,
    r: 3.191,
    transform: "matrix(0.792, -0.611, 0.611, 0.792, 0, 3.896)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(0 2.526)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 3.191,
    cy: 3.191,
    r: 3.191,
    transform: "translate(0 2.132) rotate(-19.517)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(22.847 19.279)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 3.191,
    cy: 3.191,
    r: 3.191,
    transform: "matrix(0.942, -0.335, 0.335, 0.942, 0, 2.141)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937",
    transform: "translate(4.664 7.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M2301.411,1375.7l-1.6.636c-.032-.081-3.277-8.15-8.43-13.68l1.259-1.173C2298.019,1367.249,2301.275,1375.353,2301.411,1375.7Z",
    transform: "translate(-2291.382 -1361.478)",
    fill: "#6a678a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(13.376 23.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M2331.305,1441.17l-1.35-1.067a34.781,34.781,0,0,1,11.648-8.654l.742,1.552A33.541,33.541,0,0,0,2331.305,1441.17Z",
    transform: "translate(-2329.956 -1431.449)",
    fill: "#6a678a"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M498.869,786.421s-54.817,1.355-116.2,52.3-155,102.824-219.259,104.474-85.951-28.835-85.951-28.835",
    transform: "translate(102.538 -221.635)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M700.551,873.068s-79.153,3.985-126.191,46.417c-41.121,37.094-121.308,91.081-189.978,10.208s-200.195-53.7-237.873-26.456",
    transform: "translate(49.084 -288.714)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M599.163,579.52s-43.257,6.634-68.3,39.618c-16.986,22.371-66.026,68.521-173.748,61.457",
    transform: "translate(-113.958 -61.46)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "BIG_PLANE",
    "data-name": "BIG PLANE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(473.371 546.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M1395.313,718.366,1376.5,738.09l237.26-31.942Z",
    transform: "translate(-1376.5 -706.148)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M1459.8,718.366l40.122,70.422,178.325-82.64Z",
    transform: "translate(-1440.991 -706.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M1541.187,711.187l21.743,77.6,178.325-82.64Z",
    transform: "translate(-1503.994 -706.148)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M1541.187,711.187l39.743,40.14,160.325-45.179Z",
    transform: "translate(-1503.994 -706.148)",
    fill: "#c5e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M1541.187,711.187l44.147,28.115,155.921-33.154Z",
    transform: "translate(-1503.994 -706.148)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Logo_NIKE",
    d: "M1.4,4.515a1.549,1.549,0,0,1-.928-.31,1.853,1.853,0,0,1-.193-.193,1.2,1.2,0,0,1-.209-.376A2.166,2.166,0,0,1,.269,2.1,6.846,6.846,0,0,1,1.469.4C1.56.3,1.83,0,1.832,0S1.818.026,1.8.057a3.634,3.634,0,0,0-.372.859,1.541,1.541,0,0,0,.042,1.109,1.084,1.084,0,0,0,.474.473,2.272,2.272,0,0,0,1.465.041c.042-.01,2.144-.568,4.671-1.24L12.675.077,3.756,3.893c-.483.206-.612.258-.839.338A4.253,4.253,0,0,1,1.4,4.515Z",
    transform: "translate(557.846 564.789) rotate(-3)",
    fill: "#f60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SMALL_PLANE",
    "data-name": "SMALL PLANE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(455.94 500.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M1306.472,508.071l-7.156,7.5,90.25-12.15Z",
    transform: "translate(-1299.315 -503.424)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M1331,508.071l15.261,26.787,67.832-31.435Z",
    transform: "translate(-1323.847 -503.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M1361.959,505.341l8.27,29.518,67.832-31.435Z",
    transform: "translate(-1347.812 -503.424)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M1361.959,505.341l15.117,15.268,60.985-17.185Z",
    transform: "translate(-1347.812 -503.424)",
    fill: "#c5e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M1361.959,505.341l16.793,10.694,59.309-12.611Z",
    transform: "translate(-1347.812 -503.424)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Logo_NIKE-2",
    "data-name": "Logo_NIKE",
    d: "M.483,1.56a.535.535,0,0,1-.321-.107A.639.639,0,0,1,.1,1.386a.416.416,0,0,1-.072-.13A.748.748,0,0,1,.093.725,2.365,2.365,0,0,1,.507.138L.633,0,.622.02a1.256,1.256,0,0,0-.129.3A.532.532,0,0,0,.508.7.374.374,0,0,0,.671.863a.785.785,0,0,0,.506.014L2.791.448,4.378.027,1.3,1.345c-.167.071-.211.089-.29.117A1.469,1.469,0,0,1,.483,1.56Z",
    transform: "translate(487.885 506.575) rotate(-3)",
    fill: "#f60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MEDIUM_PLANE",
    "data-name": "MEDIUM PLANE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(703.183 568.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M2403.094,808.743l-8.992,9.427L2507.5,802.9Z",
    transform: "translate(-2394.102 -802.904)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M2433.917,808.743l19.176,33.657,85.229-39.5Z",
    transform: "translate(-2424.925 -802.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M2472.813,805.312,2483.2,842.4l85.228-39.5Z",
    transform: "translate(-2455.037 -802.904)",
    fill: "#d0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M2472.813,805.312l18.995,19.184,76.625-21.593Z",
    transform: "translate(-2455.037 -802.904)",
    fill: "#c5e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M2472.813,805.312l21.1,13.437,74.521-15.846Z",
    transform: "translate(-2455.037 -802.904)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Logo_NIKE-3",
    "data-name": "Logo_NIKE",
    d: "M1.047,3.382a1.16,1.16,0,0,1-.7-.232,1.389,1.389,0,0,1-.144-.145.9.9,0,0,1-.157-.282A1.623,1.623,0,0,1,.2,1.573,5.129,5.129,0,0,1,1.1.3c.068-.076.271-.3.272-.3L1.348.042a2.723,2.723,0,0,0-.279.643,1.154,1.154,0,0,0,.032.831.812.812,0,0,0,.355.354,1.7,1.7,0,0,0,1.1.031c.032-.007,1.606-.425,3.5-.929L9.494.057,2.814,2.916c-.362.155-.458.194-.628.253A3.185,3.185,0,0,1,1.047,3.382Z",
    transform: "translate(746.738 575.668) rotate(-2)",
    fill: "#f60"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCloud);
export default __webpack_public_path__ + "static/media/contact_cloud.dadf47c82a5ced7075cab5d1d65167d4.svg";
export { ForwardRef as ReactComponent };